import React from "react";
import { Box, CircularProgress, Typography, useTheme } from "@mui/material";
import { useGetGeographyQuery } from "state/api";
import { PageContainer } from "components/shared";
import { ResponsiveBar } from "@nivo/bar";

const Geography = () => {
  const theme = useTheme();
  const { data, isLoading } = useGetGeographyQuery();

  const rows = [...(data?.data ?? [])]
    .filter((r) => r && r.state)
    .sort((a, b) => (b.revenue || 0) - (a.revenue || 0))
    .map((r) => ({
      state: r.state,
      revenue: r.revenue || 0,
      orders: r.orders || 0,
    }));

  return (
    <PageContainer title="Geography" subtitle="Revenue by state across India">
      <Box
        height="75vh"
        border={`1px solid ${theme.palette.divider}`}
        borderRadius="12px"
      >
        {isLoading || !data ? (
          <Box
            height="100%"
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <CircularProgress color="secondary" />
          </Box>
        ) : rows.length === 0 ? (
          <Box
            height="100%"
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <Typography color="text.secondary">
              No regional sales data available yet.
            </Typography>
          </Box>
        ) : (
          <ResponsiveBar
            data={rows}
            keys={["revenue"]}
            indexBy="state"
            layout="horizontal"
            margin={{ top: 30, right: 60, bottom: 60, left: 130 }}
            padding={0.3}
            valueScale={{ type: "linear" }}
            indexScale={{ type: "band", round: true }}
            colors={() => theme.palette.secondary.main}
            borderColor={{ from: "color", modifiers: [["darker", 1.6]] }}
            theme={{
              axis: {
                domain: {
                  line: {
                    stroke: theme.palette.divider,
                  },
                },
                legend: {
                  text: {
                    fill: theme.palette.text.primary,
                  },
                },
                ticks: {
                  line: {
                    stroke: theme.palette.divider,
                    strokeWidth: 1,
                  },
                  text: {
                    fill: theme.palette.text.secondary,
                  },
                },
              },
              legends: {
                text: {
                  fill: theme.palette.text.secondary,
                },
              },
              tooltip: {
                container: {
                  background: theme.palette.background.paper,
                  color: theme.palette.text.primary,
                },
              },
            }}
            axisBottom={{
              tickSize: 5,
              tickPadding: 5,
              tickRotation: 0,
              legend: "Revenue (₹)",
              legendPosition: "middle",
              legendOffset: 42,
              format: (v) => Number(v).toLocaleString("en-IN"),
            }}
            axisLeft={{
              tickSize: 5,
              tickPadding: 5,
              tickRotation: 0,
              legend: "State",
              legendPosition: "middle",
              legendOffset: -110,
            }}
            enableLabel={false}
            valueFormat={(v) => `₹${Number(v).toLocaleString("en-IN")}`}
            role="application"
            barAriaLabel={(e) =>
              `${e.indexValue}: ₹${Number(e.value).toLocaleString("en-IN")}`
            }
          />
        )}
      </Box>
    </PageContainer>
  );
};

export default Geography;
